import { useContext, useState } from 'react';
import Button from '../../common/button/Button';
import FormField from '../../common/FormField/FormField';
import { PopUpContext } from '../../common/popUp/PopUp';
import LargeIcon from '../../svg/logo/LargeIcon';
import MediumIcon from '../../svg/logo/MediumIcon';
import { FormDataContext } from '../FormContext';
import axios from 'axios';
import Login from '../login/Login';
import './signUp.scss';
import AuthContext from '../../../store/auth-context';

const SignUp = () => {
  const popUp = useContext(PopUpContext);
  const signUpContext = useContext(FormDataContext);
  console.log('err =' + signUpContext.signUp.email.value.err);

  const username = signUpContext.signUp.username.value.val;
  const email = signUpContext.signUp.email.value.val;
  const password = signUpContext.signUp.password.value.val;
  const confirm = signUpContext.signUp.confirm.value.val;

  const handleSubmits = async (e) => {
    e.preventDefault();

    fetch('http://localhost:8080/auth/signup', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: username,
        email: email,
        password: password,
        confirm: confirm,
      }),
    })
      .then((res) => {
        if (res.status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (res.status !== 200 && res.status !== 201) {
          console.log('Error!');
          throw new Error('Creating a user failed!');
        }
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        window.location.replace('/');
      })
      .catch((err) => {
        console.log(err);
      });
    // try {
    //   const res = await axios.post('auth/signup', {
    //     username,
    //     email,
    //     password,
    //     confirm,
    //   });
    //   res.data && window.location.replace('/');
    //   console.log(res.data)
    // } catch (err) {
    //   console.log(err);
    // }
  };

  return (
    <>
      <form className="signUpContainer next" onSubmit={handleSubmits}>
        <button
          className="back"
          onClick={() => {
            popUp.showPopUp('small', <Login direction="previous" />);
          }}
        >
          back
        </button>
        <div className="logo">
          <MediumIcon />
        </div>

        <FormField
          type="text"
          name="fullName"
          message={signUpContext.signUp.username.value.err}
          value={signUpContext.signUp.username.value.val}
          onBlur={() => {}}
          changeTo={(text) => {
            signUpContext.signUp.username.changeTo(text);
          }}
          placeholder="Full name"
        />
        <FormField
          type="email"
          name="email"
          message={signUpContext.signUp.email.value.err}
          value={signUpContext.signUp.email.value.val}
          onBlur={(text) => {
            signUpContext.signUp.email.checkError(text);
          }}
          changeTo={(text) => {
            signUpContext.signUp.email.changeTo(text);
          }}
          placeholder="Email Adress"
        />
        <FormField
          type="password"
          name="Password"
          message={signUpContext.signUp.password.value.err}
          value={signUpContext.signUp.password.value.val}
          onBlur={(text) => {
            signUpContext.signUp.password.checkError(text);
          }}
          changeTo={(text) => {
            signUpContext.signUp.password.changeTo(text);
          }}
          placeholder="Password"
        />
        <FormField
          type="password"
          name="confirmPassword"
          message={signUpContext.signUp.confirm.value.err}
          value={signUpContext.signUp.confirm.value.val}
          onBlur={(text) => {
            signUpContext.signUp.confirm.checkError(text);
          }}
          changeTo={(text) => {
            signUpContext.signUp.confirm.changeTo(text);
          }}
          placeholder="Confirm password"
        />
        <div className="passwordCondition container">
          <p>
            Password should be atleast 6 characters long and should include
            atleast 1 special character. Ex: @,$,%,&,!.
          </p>
        </div>
        <div className="container temrsCondition">
          <input
            type="checkbox"
            checked={signUpContext.signUp.termsAndCondition.value}
            onClick={() => {
              signUpContext.signUp.termsAndCondition.changeTo();
            }}
          />
          <p>
            By signing up, you agree to MyNextMUN’s <a>Conditions of Use</a> and{' '}
            <a>Privacy Policy</a>.
          </p>
        </div>
        <button
          className="formBtn"
          disabled={!signUpContext.signUp.termsAndCondition.value}
        >
          Sign Up
        </button>
      </form>
    </>
  );
};
export default SignUp;
